<template>
    <div class="form-agency-contacts">
        <div class="row">
            <div class="col-xl-10 col-lg-9 col-md-9"></div>
            <div class="col-xl-2 col-lg-3 col-md-3 agency-contacts-column">
                <div class="btn-wrap">
                    <button
                        @click.prevent="toggleContactModal"
                        class="btn btn--gray"
                    >
                        Add contact
                    </button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12">
                <div class="table-wrap">
                    <table class="table table--tabs">
                        <thead>
                            <tr>
                                <th>Last name</th>
                                <th>First name</th>
                                <th>Title</th>
                                <th>E-mail</th>
                                <th>
                                    Main contact
                                    <span>
                                        <i class="icon icon-down-arrow"></i>
                                    </span>
                                </th>
                                <th>Role</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="loading">
                                <td colspan="16">
                                    <clip-loader
                                        :loading="loading"
                                        :color="'#ec4657'"
                                        :size="'45px'"
                                    ></clip-loader>
                                </td>
                            </tr>
                            <tr v-else-if="!contacts.length && !loading">
                                <td colspan="16">
                                    <center>No data</center>
                                </td>
                            </tr>
                            <tr
                                v-else-if="contacts.length"
                                v-for="(contact, index) of contacts"
                                :key="index"
                            >
                                <td>{{ contact.lastname }}</td>
                                <td>{{ contact.firstname }}</td>
                                <td>{{ contact.title }}</td>
                                <td>{{ contact.email }}</td>
                                <td class="checkbox">
                                    <div class="form-field checkbox-wrap">
                                        <input
                                            disabled
                                            :checked="contact.main_contact"
                                            type="checkbox"
                                            :id="
                                                `user_main_contact_` +
                                                contact.id
                                            "
                                            value=""
                                            name="master_invoice[]"
                                        />
                                        <label
                                            :for="
                                                `user_main_contact_` +
                                                contact.id
                                            "
                                        >
                                            <i class="icon icon-checkmark"></i>
                                        </label>
                                    </div>
                                </td>

                                <td>
                                    <p v-for="role of contact.role">
                                        {{ role }}
                                    </p>
                                </td>
                                <td>
                                    <button
                                        @click="
                                            (e) =>
                                                handleEditContact(e, contact.id)
                                        "
                                        class="btn btn--icon"
                                        type="button"
                                    >
                                        <i class="icon icon-pencil"></i>
                                    </button>
                                    <button
                                        @click="deleteContact(contact.id)"
                                        class="btn btn--icon"
                                        type="button"
                                    >
                                        <i class="icon icon-trash"></i>
                                    </button>
                                    <!-- <div class="error" v-if="error && contact.main_contact">{{ error }}</div> -->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <addContactModal
            v-if="isAddContact"
            :countries="countries"
            :onAdd="addContact"
            :isEdit="editContactId"
            :onEdit="editContact"
            :editData="editContactData"
            :roles="roles"
            :closeModal="toggleContactModal"
        />
    </div>
</template>

<script>
import axios from "axios";
import ClipLoader from "vue-spinner/src/ClipLoader";
import addContactModal from "./addContactModal.vue";

export default {
    name: "Index",

    props: ["company", "roles", "countries"],

    components: {
        ClipLoader,
        addContactModal,
    },

    data() {
        return {
            loading: false,
            editContactId: null,

            contacts: [],
            isAddContact: false,
        };
    },

    mounted() {
        console.log(this.roles);

        this.getUserList();
    },

    computed: {
        editContactData() {
            if (this.editContactId && this.contacts.length) {
                let a = this.contacts.find(
                    (contact) => contact.id === this.editContactId
                );
                return a;
            }
            return null;
        },
    },

    methods: {
        getUserList() {
            this.loading = true;

            axios
                .post("/api/contacts/getContactsByRelation", {
                    companyId: this.company.id,
                })
                .then((res) => {
                    this.loading = false;

                    this.contacts = res.data;
                })
                .catch((err) => {
                    this.loading = false;
                });
        },

        addContact(params) {
            axios
                .post("/api/contacts/add", {
                    companyId: this.company.id,
                    contact: params.contact,
                    address: params.address,
                })
                .then((r) => {
                    if (r.data.isSuccess) {
                        this.isAddContact = false;

                        this.getUserList();
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.data) {
                        const responseData = error.response.data;
                        if (
                            responseData.errors.hasOwnProperty("contact.email")
                        ) {
                            let message = responseData.errors[
                                "contact.email"
                            ][0].replace("contact.", "");
                            errorValidate(
                                "Contact with this e-mail already exists",
                                [document.getElementById("email")]
                            );
                        } else {
                            errorValidate("", [
                                document.getElementById("email"),
                            ]);
                        }
                        console.log("Error response data:", responseData);
                    } else {
                        console.log("Error occurred:", error);
                    }
                });
        },

        handleEditContact(e, id) {
            this.editContactId = id;
            this.toggleContactModal(e);
        },

        editContact(id, contact, address) {
            axios
                .post("/api/contacts/update", {
                    contactId: id,
                    contact,
                    address,
                })
                .then((r) => {
                    if (r.data.isSuccess) {
                        this.getUserList();

                        this.editContactId = null;
                        this.isAddContact = false;
                    }
                });
        },

        deleteContact(id) {
            if (confirm("are you sure?")) {
                axios
                    .post("/api/contacts/delete", {
                        contactId: id,
                    })
                    .then((r) => {
                        this.getUserList();
                    });
            }
        },

        toggleContactModal(e) {
            e.preventDefault();
            this.isAddContact = !this.isAddContact;
            if (!this.isAddContact) {
                this.editContactId = null;
            }
        },
    },
};

function errorValidate(message, selectors = []) {
    if (selectors.length) {
        selectors.forEach((input) => {
            const span = input.nextElementSibling;
            span.innerHTML = message;
            if (message != "") {
                input.classList.add("error-validate");
            } else {
                input.classList.remove("error-validate");
            }
        });
    }
}
</script>

<style scoped></style>
